import { render } from "./restyle_menu_mobile.vue?vue&type=template&id=1cb33ca8&scoped=true"
import script from "./restyle_menu_mobile.vue?vue&type=script&lang=js"
export * from "./restyle_menu_mobile.vue?vue&type=script&lang=js"

import "./restyle_menu_mobile.vue?vue&type=style&index=0&id=1cb33ca8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb33ca8"]])

export default __exports__